import JSZip from "jszip";
import type { DocParts } from "./paperFormat";

/** Thrown when the file is not a readable Word document (not a zip, or a zip with no word/document.xml). */
export class NotDocxError extends Error {
  constructor() { super("not a Word document"); this.name = "NotDocxError"; }
}

/** Reads the parts of a .docx that the format check needs. Everything stays in the browser. */
export async function readDocxParts(data: Blob | ArrayBuffer | Uint8Array): Promise<DocParts> {
  let zip: JSZip;
  try { zip = await JSZip.loadAsync(data); } catch { throw new NotDocxError(); }
  const text = async (n: string) => (await zip.file(n)?.async("text")) || undefined;
  const document = await text("word/document.xml");
  if (!document) throw new NotDocxError();
  const headers: string[] = [];
  for (const name of Object.keys(zip.files)) if (/^word\/(header|footer)\d*\.xml$/.test(name)) headers.push((await text(name)) || "");
  return { document, styles: await text("word/styles.xml"), theme: await text("word/theme/theme1.xml"), headers };
}
